import(/* webpackMode: "eager" */ "/home/interim/frontend/app/privacy/page.tsx");
